import { Loader2 } from 'lucide-react'
import { TOOL_LABELS } from '@/types/streaming'

interface ToolCallIndicatorProps {
  toolName: string
}

export function ToolCallIndicator({ toolName }: ToolCallIndicatorProps) {
  const label = TOOL_LABELS[toolName] || `Running ${toolName}...`

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground mt-1 rounded-md bg-primary/5 border border-primary/10 px-2 py-1 animate-in fade-in duration-200 animate-shimmer">
      <Loader2 className="h-3 w-3 animate-spin text-primary" />
      <span>{label}</span>
    </div>
  )
}
